// @flow
import React from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { ConfigurableAttribute } from '../../flowtypes/product';
import InputCreator, { type $defaultInputProps } from '../../containers/ProductForm/InputCreator';
import { Attribute, getSelectOptions } from '../../types/attributes';
import './SelectInput.css';

type SelectInputProps = {
  defaultInputProps: $defaultInputProps,
  attribute: ConfigurableAttribute,
  setAttributeValue: Function,
};

const SelectInput = InputCreator(({
  defaultInputProps,
  attribute,
}: SelectInputProps) => (
  <Select
    placeholder="Choose an Option..."
    name={attribute.id}
    searchable={false}
    clearable={false}
    options={getSelectOptions(Attribute(attribute)).getOrElseValue([])}
    {...defaultInputProps}
    onChange={({ value }) => { defaultInputProps.onChange({ target: { name: attribute.id, value } }); }}
  />
));

export default SelectInput;



// WEBPACK FOOTER //
// ./src/components/SelectInput/index.js